import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ReactSVG } from 'react-svg';

import logo from 'assets/images/mpr.svg';
import msuLogo from 'assets/images/msu.svg';

import {
    FullScreenCover,
    HeadingContent,
    WelcomeContent,
} from './WelcomeScreen.styled';

const list = {
    hidden: {
        opacity: 0,
    },
    show: {
        opacity: 1,
        transition: { duration: 1, ease: 'linear' },
    },
};

export const WelcomeScreen = (): JSX.Element => {
    return (
        <FullScreenCover>
            <HeadingContent>
                <a
                    href="https://www.msu.ru/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="msu-logo"
                >
                    <ReactSVG src={msuLogo} />
                </a>

                <a
                    href="https://ecology-gosdoklad.ru/"
                    rel="noopener noreferrer"
                >
                    <ReactSVG src={logo} />
                </a>
            </HeadingContent>

            <WelcomeContent>
                <h2>Государственный доклад</h2>
                <h1>
                    О&nbsp;состоянии и&nbsp;об&nbsp;охране окружающей среды
                    Российской&nbsp;Федерации в&nbsp;2022&nbsp;году
                </h1>

                <motion.div
                    className="spin-wrapper"
                    initial="hidden"
                    animate="show"
                    variants={list}
                >
                    <motion.div
                        className="text-bg"
                        animate={{
                            scale: 1,
                        }}
                        whileHover={{
                            scale: [1, 0.3, 1.2],
                            background: 'rgba(255,255,255,0.35',
                            transition: {
                                duration: 0.3,
                            },
                        }}
                    >
                        <Link to="/report">Изучить</Link>
                    </motion.div>

                    <motion.span
                        className="spin-quarter"
                        animate={{
                            rotate: 360,
                            transition: {
                                loop: Infinity,
                                duration: 2,
                                ease: 'linear',
                            },
                        }}
                        whileHover={{
                            background: 'red',
                            transition: {
                                loop: Infinity,
                                duration: 2,
                                ease: 'linear',
                            },
                        }}
                    />
                    <motion.span
                        className="spin-quarter"
                        animate={{
                            rotate: -360,
                            transition: {
                                loop: Infinity,
                                duration: 2,
                                ease: 'linear',
                            },
                        }}
                    />
                    <motion.span
                        className="spin-quarter"
                        animate={{
                            rotate: 360,
                            transition: {
                                loop: Infinity,
                                duration: 2,
                                ease: 'linear',
                            },
                        }}
                    />
                    <motion.span
                        className="spin-quarter"
                        animate={{
                            rotate: -360,
                            transition: {
                                loop: Infinity,
                                duration: 2,
                                ease: 'linear',
                            },
                        }}
                    />
                </motion.div>
            </WelcomeContent>
        </FullScreenCover>
    );
};
